<div class="container px-4">
  <div class="equipment-page">
    <!-- Header Section -->
    <header class="page-header">
      <h1>Equipment</h1>
      <p>View all equipment items assigned to your account.</p>
    </header>

    <!-- Equipment Card -->
    <div class="equipment-card">
      <div class="equipment-details">
        <div class="menu-icon flex justify-end items-center w-full">
          <button type="button" class="text-[#585C67]">
            <i class="ri-more-2-line text-[20px]"></i>
          </button>
        </div>
        <div class="flex justify-between items-center w-full flex-wrap gap-4 md:gap-0">
          <div class="details flex flex-col items-center md:items-start justify-center  w-full md:w-1/2">
            <img src="/icons/router.png" alt="" />
            <div>
              <p class="label">Manufacturer</p>
              <p class="value">Ubiquiti</p>
            </div>
          </div>
          <div class="details flex flex-col items-center md:items-start  justify-center w-full md:w-1/2">
            <img src="/icons/router.png" alt="" />
            <div class="flex flex-col items-center justify-center">
              <p class="label">Model</p>
              <p class="value">UFiber XGS</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
